import { render, staticRenderFns } from "./SituationChart.vue?vue&type=template&id=196ad27c&"
import script from "./SituationChart.vue?vue&type=script&lang=js&"
export * from "./SituationChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports